<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">视频通话</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <div style="padding: 20px;">
          <div>
            <div style="float: left;width: 50%">
              <div>本机</div>
              <video ref="local" id="local_view" autoplay controls muted></video>
            </div>
            <div style="float: left;width: 50%">
              <div>客户</div>
              <video ref="remote" id="remote_view" autoplay controls muted></video>
              <video ref="remote2" id="remote_view2" autoplay controls muted style="width: 300px;height: 50px;"></video>
            </div>
            <div style="clear:both;"></div>
          </div>
        </div>


        <div id="left">
          <p id="p_websocket_state" style="color: white">连接信息</p>

          <!--        <button id="btn_connect" class="my_button" onclick="connect()">连接</button>-->

<!--          <button class="my_button" onclick="call()">拨打</button>-->

<!--          <button class="my_button" onclick="recall()">接听</button>-->
          <!--<button class="my_button" onclick="reject()">拒绝</button>-->

          <button class="my_button" onclick="hangUp()">挂断</button>


        </div>

      </div>

    </div>
  </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: 'Add',
  props:[],
  data() {
    return {
      tableLoading: false,
      userCode:'',


      peerConnection:null,
      localStream:null,

      dic_init:{
        "id": "id",
        "from": 12,
        "fromName": "往事",
        "to": 11,
        "toName": "王安",
        "isSucceed": 0
      },
      offerAnswerOptions : {
        offerToReceiveAudio: 1,
        offerToReceiveVideo: 1
      },

      websocket:null,

      userCodeSend:'',
      userCodeReceive:'',
      messageCode:'',
      hadInfo:false,

      th:0,


    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  created(){

    this.th = this.$store.state.tableHeight;

    window.recall = this.recall;
    window.hangUp = this.hangUp;

    //this.init();

  },
  methods: {
    init(row){
      let that = this;

      that.userCode = row.userCode;



      that.userCodeSend = getStaffCode();
      that.userCodeReceive = that.userCode;
      that.messageCode = '';
      //this.hadInfo = hadInfo;

      that.dic_init = {
        "id": "id",
        "from": that.userCodeSend,
        "fromName": that.userCodeSend,
        "to": that.userCodeReceive,
        "toName": that.userCodeReceive,
        "isSucceed": 0
      };




      navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then(function (mediaStream) {

        console.log(mediaStream);

        // 初始化 PeerConnectionFactory
        // 创建 EglBase
        // 创建 PeerConnectionFactory
        // 创建音轨
        // 创建视轨
        that.localStream = mediaStream;
        // 初始化本地视频渲染控件
        // 初始化远端视频渲染控件
        // 开始本地渲染
        that.$refs.local.srcObject = mediaStream;

        that.connect();

        that.sendVideo();

      }).catch(function (error) {
        console.log("error--->" + error);
      })


    },

    closeSelf() {
      this.hangUp();
      this.$emit("closeMe");
    },





    createPeerConnection() {

      let that = this;

      let peerConnectionConfig = {
        iceServers: [
          {urls: 'stun:stun.l.google.com:19302'},

          //{urls: 'stun:62.234.80.224:3478'},
          //{urls : 'turn:62.234.80.224:3478', credential: 'test', username: 'test'},

          {urls: 'stun:39.107.54.217:3478'},
          {urls : 'turn:39.107.54.217:3478', credential: 'test', username: 'test'},

        ],


        //iceTransportPolicy: "all", // all或者 "relay"，根据你的需求选择
        //bundlePolicy: 'max-bundle',
        //rtcpMuxPolicy: 'require',
        //iceCandidatePoolSize: 10,

        //enableDtlsSrtp: true // 启用DTLS-SRTP
      };

      //bundlePolicy
      //Banlanced：音频与视频轨使用各自的传输通道
      //max-compat：每个轨使用自己的传输通道
      //max-bundle：都绑定到同一个传输通道


      //let rtcPeerConnection = new RTCPeerConnection({});
      let rtcPeerConnection = new RTCPeerConnection(peerConnectionConfig);
      console.log("create rtcPeerConnection success.");

      rtcPeerConnection.oniceconnectionstatechange = function (event) {

        console.log("777777777777777");
        console.log("oniceconnectionstatechange->"+event.target.iceConnectionState);
        if ("disconnected" == event.target.iceConnectionState) {
          //hangUp();
        }
      }

      rtcPeerConnection.onicecandidate = function (event) {
        //console.log("onicecandidate--->" +event.candidate);
        console.log("===onicecandidate===");
        console.log(event);

        let iceCandidate = event.candidate;
        if (iceCandidate == null) {
          return;
        }
        that.sendIceCandidate(iceCandidate);
      }
      rtcPeerConnection.ontrack = function (event) {
        console.log("remote ontrack--->" + event.streams);
        console.log(event);
        let streams = event.streams;
        if (streams && streams.length > 0) {
          console.log("streams[0]--->" + streams[0]);
          that.$refs.remote.srcObject = streams[0];
        }

        console.log(event.track.kind);
        if (event.track.kind === 'audio') {
          // const audioElement = document.getElementById('remote-audio');
          // audioElement.srcObject = new MediaStream([event.track]);
          // audioElement.play();

          that.$refs.remote2.srcObject = streams[0];

        } else if (event.track.kind === 'video') {
          // const videoElement = document.getElementById('remote-video');
          // videoElement.srcObject = new MediaStream([event.track]);
          // videoElement.play();
        }


      }
      return rtcPeerConnection
    },

    call(){
      let dic = JSON.parse(JSON.stringify(this.dic_init));
      dic["id"] = "call";
      this.send(JSON.stringify(dic));
    },
    reject(){
      let dic = JSON.parse(JSON.stringify(this.dic_init));
      dic["id"] = "incall";
      dic["isSucceed"] = 2;
      this.send(JSON.stringify(dic));
    },
    recall(){
      let dic = JSON.parse(JSON.stringify(this.dic_init));
      dic["id"] = "incall";
      dic["isSucceed"] = 1;
      this.send(JSON.stringify(dic));
    },
    call_response() {
      let that = this;
      // 创建 PeerConnection
      this.peerConnection = this.createPeerConnection();
      // 为 PeerConnection 添加音轨、视轨
      for (let i = 0; this.localStream != null && i < this.localStream.getTracks().length; i++) {
        const track = this.localStream.getTracks()[i];
        //peerConnection.addTrack(track, localStream);
      }
      this.localStream.getTracks().forEach(track => this.peerConnection.addTrack(track, this.localStream));

      // 通过 PeerConnection 创建 offer，获取 sdp
      this.peerConnection.createOffer(this.offerAnswerOptions).then(function (sessionDescription) {
        console.log("create offer success.");
        console.log("=======2:setLocalDescription=======");
        // 将 offer sdp 作为参数 setLocalDescription
        that.peerConnection.setLocalDescription(sessionDescription).then(function () {
          console.log("set local sdp success.");
          // 发送 offer sdp
          that.sendOffer(sessionDescription)
        })
      })
    },

    sendOffer(offer) {

      console.log("=====3:send offer sdp=====OFFER=====");

      let dic = JSON.parse(JSON.stringify(this.dic_init));
      dic["id"] = "offer";
      dic["sessionDescription"] = {
        "type": "OFFER",//offer.type,
        "description": offer.sdp.replace("\r\na=extmap-allow-mixed","")
      }
      this.send(JSON.stringify(dic));
    },


    hangUp() {

      if (this.peerConnection != null) {
        this.peerConnection.close();
        this.peerConnection = null;
      }


      //this.$refs.remote.removeAttribute('src');
      this.$refs.remote.srcObject = null;
      this.$refs.remote.load();

      //this.$refs.local.removeAttribute('src');
      this.$refs.local.srcObject = null;
      this.$refs.local.load();

      if(this.websocket != null){
        this.disconnect();
      }

      if(this.messageCode !=''){
        this.sendClose();
      }

    },


    receivedOffer(offer) {

      let that = this;

      // 创建 PeerConnection
      this.peerConnection = this.createPeerConnection();

      // 为 PeerConnection 添加音轨、视轨
      for (let i = 0; this.localStream != null && i < this.localStream.getTracks().length; i++) {
        const track = this.localStream.getTracks()[i];
        //peerConnection.addTrack(track, localStream);
      }
      this.localStream.getTracks().forEach(track => that.peerConnection.addTrack(track, that.localStream));

      // 将 offer sdp 作为参数 setRemoteDescription
      this.peerConnection.setRemoteDescription(offer).then(function () {
        console.log("set remote sdp success.");

        console.log("=======5:createAnswer========");
        // 通过 PeerConnection 创建 answer，获取 sdp
        that.peerConnection.createAnswer(that.offerAnswerOptions).then(function (sessionDescription) {
          console.log("create answer success.");

          console.log("==========6:setLocalDescription============");
          // 将 answer sdp 作为参数 setLocalDescription
          that.peerConnection.setLocalDescription(sessionDescription).then(function () {
            console.log("set local sdp success.");
            // 发送 answer sdp
            that.sendAnswer(sessionDescription);
          })
        })
      })
    },
    sendAnswer(answer) {

      console.log("=====7:send offer sdp=====ANSWER=====");

      let dic = JSON.parse(JSON.stringify(this.dic_init));
      dic["id"] = "offer";
      dic["sessionDescription"] = {
        "type": "ANSWER",
        "description": answer.sdp
      }

      this.send(JSON.stringify(dic));

    },



    receivedAnswer(answer) {
      let that = this;
      // 收到 answer sdp，将 answer sdp 作为参数 setRemoteDescription
      that.peerConnection.setRemoteDescription(answer).then(function () {
        console.log("set remote sdp success.");
      })
    },
    sendIceCandidate(iceCandidate) {

      let dic = JSON.parse(JSON.stringify(this.dic_init));
      dic["id"] = "candidate";
      dic["iceCandidate"] = {
        "sdpMid": iceCandidate.sdpMid,
        "sdpMLineIndex": iceCandidate.sdpMLineIndex,
        "sdp": iceCandidate.candidate,
        "serverUrl": iceCandidate.url
      }
      this.send(JSON.stringify(dic));
    },
    receivedCandidate(iceCandidate) {
      this.peerConnection.addIceCandidate(iceCandidate);
    },

    connect() {

      let that = this;

      let pWebsocketState = document.getElementById("p_websocket_state");

      //let url = "ws://118.89.66.71:9987/websocket_one_to_one";
      let url = this.$websocketUrl.replace("/websocket/","/websocket_one_to_one");

      let websocket = new WebSocket(url);
      this.websocket = websocket;
      websocket.onopen = function () {
        console.log("onOpen");
        pWebsocketState.innerText = "WebSocket 已连接";

        let dic = JSON.parse(JSON.stringify(that.dic_init));
        dic["id"] = "register";
        this.send(JSON.stringify(dic));

      }
      websocket.onmessage = function (message) {
        //console.log("onmessage--->" + message.data);
        let jsonObject = JSON.parse(message.data);
        let id = jsonObject["id"];
        let isSucceed = jsonObject["isSucceed"];

        if(id == "register_response"){
          console.log("注册成功返回");

          //直接接听
          //that.recall();
        }
        if(id == "call_response"){
          if(isSucceed == 2){
            console.log("对方不在线，连接失败");
          }
        }
        if(id == "incall"){
          pWebsocketState.innerText = "收到来电，是否接听";
          console.log("收到来电，是否接听");
        }
        if(id == "incall_response"){
          if(isSucceed == 1){
            console.log("被呼叫者已接听，呼叫方开始创建sdp offer");
            console.log("========1:createOffer=======");
            that.call_response();
          }
          if(isSucceed == 2){
            console.log("对方拒绝接听线");
          }
          pWebsocketState.innerText = "收到来电，是否接听";
          console.log("收到来电，是否接听");
        }
        if(id == "offer"){
          let sessionDescription = jsonObject["sessionDescription"];
          let type = sessionDescription["type"];
          let description = sessionDescription["description"];

          if(type == "OFFER"){
            console.log("====4:setRemoteDescription====OFFER===");
            let options = {
              "type": "offer",
              "sdp": description
            }
            let offer = new RTCSessionDescription(options);
            that.receivedOffer(offer);
          }
          if(type == "ANSWER"){
            console.log("====8:setRemoteDescription===ANSWER===");

            let options = {
              "type": "answer",
              "sdp": description
            }
            let answer = new RTCSessionDescription(options);
            that.receivedAnswer(answer);
          }

        }
        if(id == "candidate"){
          //console.log("onmessage--->" + message.data);
          let iceCandidate = jsonObject["iceCandidate"];
          let options3 = {
            "sdpMLineIndex": iceCandidate["sdpMLineIndex"],
            "sdpMid": iceCandidate["sdpMid"],
            "candidate": iceCandidate["sdp"]
          }
          let iceCandidate3 = new RTCIceCandidate(options3);
          that.peerConnection.addIceCandidate(iceCandidate3);

        }


      }
      websocket.onclose = function (error) {
        console.log("onclose--->" + error);
        pWebsocketState.innerText = "WebSocket 已断开";
      }
      websocket.onerror = function (error) {
        console.log("onerror--->" + error);
      }
    },
    disconnect() {
      this.websocket.close();
    },
    send(message) {
      if (!this.websocket) {
        return;
      }
      this.websocket.send(message);
    },



    getInfo(){
      let that = this;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"VideoChat/Info",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then( (response)=> {
        //console.log(response);

        if(response.data.error == 0){
          let hadInfo = response.data.data.hadInfo;
          let userCodeSend = response.data.data.userCodeSend;
          let userCodeReceive = response.data.data.userCodeReceive;
          let messageCode = response.data.data.messageCode;

          if(hadInfo){

            this.userCodeSend = userCodeSend;
            this.userCodeReceive = userCodeReceive;
            this.messageCode = messageCode;
            this.hadInfo = hadInfo;

            that.dic_init = {
              "id": "id",
              "from": userCodeSend,
              "fromName": userCodeSend,
              "to": userCodeReceive,
              "toName": userCodeReceive,
              "isSucceed": 0
            };

            that.$refs.local.srcObject = that.localStream;
            that.connect();
          }


        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }

        if(!this.hadInfo){
          setTimeout(function (){
            that.getInfo();
          },1000);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },




    sendVideo(){
      let that = this;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Message/StaffAddServe",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          userCodeReceive: this.userCode,
          message:'msg',
          messageType:'video',
        }
      }).then( (response)=> {
        //console.log(response);

        if(response.data.error == 0){

          let message = response.data.data.message;
          let messageCode = message.messageCode;
          this.messageCode = messageCode;

          that.getConnectStatusByCode(messageCode);

        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }


      }).catch(function (error) {
        console.log(error);
      });
    },

    sendClose(){
      let that = this;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Message/MessageVideoClose",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          userCode: this.userCodeSend,
          messageCode: this.messageCode,
        }
      }).then( (response)=> {
        //console.log(response);

        if(response.data.error == 0){

          //this.hadInfo = false;
          //this.getInfo();


        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }

        // setTimeout(function (){
        //   that.getInfo();
        // },1000);

      }).catch(function (error) {
        console.log(error);
      });
    },

    getConnectStatusByCode(messageCode){

      let that = this;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Message/MessageVideoInfo",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          messageCode: messageCode,
        }
      }).then( (response)=> {
        //console.log(response);

        if(response.data.error == 0){

          let messageVideo = response.data.data.messageVideo;
          let connectStatus = messageVideo.connectStatus;
          let messageCode = messageVideo.messageCode;

          if(connectStatus=="sendCancel"){
            that.hangUp();
          }
          if(connectStatus=="sendClose"){
            that.hangUp();
          }
          if(connectStatus=="receiveCancel"){
            that.hangUp();
          }
          if(connectStatus=="receiveClose"){
            that.hangUp();
          }

          if(connectStatus == "waitReceipt" || connectStatus == 'hadReceipt'){

            setTimeout(function (){
              that.getConnectStatusByCode(messageCode);
            },1000);

          }


        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }


      }).catch(function (error) {
        console.log(error);
      });

    },



  }
}


</script>

<style lang="scss" scoped>

</style>

<style>
body {
  overflow: hidden;
  margin: 0px;
  padding: 0px;
}

/*#local_view {*/
/*  width: 50%;*/
/*  height: auto;*/
/*}*/

/*#remote_view {*/
/*  width: 20%;*/
/*  height: 40%;*/
/*  position: absolute;*/
/*  top: 20px;*/
/*  right: 50%;*/
/*}*/

#left {
  width: 10%;
  height: auto;
  position: absolute;
  left: 20px;
  top: 70px;
}

#p_websocket_state,
#input_server_url,
.my_button {
  width: 100%;
  height: 100%;
  display: block;
  margin-bottom: 10%;
}
</style>
